import { Injectable } from '@angular/core';

@Injectable()
export class BuildingCheckerService {

  private tierTypeMinHeightMap = {
    tier1StepUp: 0,
    tier2StepUp: 0,
    tier3StepUp: 0,
    tier1StepDown: 40.64,
    tier2StepDown: 58.42,
    tier3StepDown: 76.2
  };

  private stairTypeMinHeightMap = {
    straightStair: 53.34,
    stairLandingLeft: 121.92,
    stairLandingRight: 121.92,
    stairLandingStraight: 53.34,
    stairLandingBothSides: 121.92
  };

  constructor() { }

  checkHeightForStairs(stairType, height): boolean {
    const minHeight = this.stairTypeMinHeightMap[stairType];

    return (height >= minHeight) ? true : false;
  }

  checkHeightForTier(tierType, height): boolean {
    const minHeight = this.tierTypeMinHeightMap[tierType];

    return (height >= minHeight) ? true : false;
  }

  checkEdge(edge): boolean {
    return (edge >= 42) ? true : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/building-checker.service.ts